module.exports = __webpack_public_path__ + "img/unionImg.b581cec5.png";